<template>
  <div>
    <!-- Datum -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.tumorkonferenz_datum'"
                           :ref="path + '.tumorkonferenz_datum'"
                           :rules="{required:true,german_date:true,date_not_in_future:true,date_must_be_greater_than_diagnosis:diagDate,date_must_be_lesser_than_death:[deathDate, model.tumorkonferenz_datum_genauigkeit]}"
                           v-slot="{ errors }">
        <lx-datepicker
            :color="compColor.textInput"
            :auto-focus="!formId"
            :name="path + '.tumorkonferenz_datum'"
            :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_DATE') + ' *'"
            :disabled="isDisabled"
            @input="setDateAccuracyAfterDate"
            :hide-details="!errors || errors.length <= 0"
            :dense="denseFields"
            :error="errors[0]"
            v-model="model.tumorkonferenz_datum"
        ></lx-datepicker>
      </validation-provider>
    </div>

    <!-- Datumsgenauigkeit Datum -->

    <div class="flex-gt-sm-50 flex-100 px-2 layout-row">
      <validation-provider tag="div"
                           class="flex"
                           :name="path + '.tumorkonferenz_datum_genauigkeit'"
                           :ref="path + '.tumorkonferenz_datum_genauigkeit'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_DATE_ACCURACY') + ' *'"
          v-model="model.tumorkonferenz_datum_genauigkeit"
          :items="DateAccuracyTypes"
          :disabled="isDisabled"
          outlined
          @change="validateDateAfterChangeOfAccuracy()"
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>

      <v-tooltip bottom open-delay="1000">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
               :class="{'mt-1': !denseFields}"
               style="cursor: pointer;">
            <v-icon :color="compColor.prime" medium>info</v-icon>
          </div>
        </template>
        <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
      </v-tooltip>
    </div>

    <!-- Typ -->

    <div class="flex-gt-sm-100 flex-100 px-2 mt-2">
      <validation-provider tag="div"
                           :name="path + '.tumorkonferenz_typ'"
                           :ref="path + '.tumorkonferenz_typ'"
                           rules="required"
                           v-slot="{ errors }">

        <!-- Typ as hidden field to define the correct associated value to validator -->

        <v-text-field
          v-model="model.tumorkonferenz_typ"
          v-show="false"
          :dense="denseFields"
          outlined
          hide-details
          :error-messages="errors[0]"
        ></v-text-field>

        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_TYPE') + ' *'"
          v-model="model.tumorConferenceTypesListItem"
          :items="Tumorkonferenz_TypTypes"
          outlined
          :disabled="isDisabled"
          hide-details
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Therapieempfehlung -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_RECOMMENDATION')"
                        :disabled="isDisabled">

        <div class="layout-column flex pa-2" v-if="model.therapieempfehlung">

          <!-- Abweichung_Patientenwunsch -->

          <div class="layout-row px-2 pb-2 mb-2 flex layout-align-start-center">
            <label class="mr-8"
                   :style="{'color': isDisabled  ? '#BDBDBD' : compColor.isInDarkMode ? '#ffffff' : '#616161', 'font-size': denseFields ? '0.9em' : '16px'}">
              {{ $t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_LABEL_DEVIATION_PATIENT_WISH') }} *
            </label>

            <validation-provider tag="div"
                                 :name="path + '.therapieempfehlung.abweichung_patientenwunsch'"
                                 :ref="path + '.therapieempfehlung.abweichung_patientenwunsch'"
                                 rules="required"
                                 class="layout-row px-0"
                                 v-slot="{ errors }">
              <v-radio-group :dense="denseFields" v-model="model.therapieempfehlung.abweichung_patientenwunsch"
                             row
                             :hide-details="!errors || errors.length <= 0"
                             :error-messages="errors[0]"
                             class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
                <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.YES')"
                         value="J" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                </v-radio>
                <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.NO')"
                         value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                </v-radio>
                <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.UNKNOWN')"
                         value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                </v-radio>
              </v-radio-group>
            </validation-provider>
          </div>

          <!-- hidden input field to show error, if array of recommendations is empty -->

          <div class="flex-gt-sm-100 flex-100 px-1">
            <validation-provider tag="div"
                                 :name="path + '.therapieempfehlung.typ_therapieempfehlungen'"
                                 :ref="path + '.therapieempfehlung.typ_therapieempfehlungen'"
                                 rules="at_least_one_therapy_recommendation_is_selected|required"
                                 v-slot="{ errors }">
              <lx-alert-box v-show="errors[0]" color="red" class="mb-3">
                {{ $t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_RECOMMENDATION_ERROR_MESSAGE') }}
              </lx-alert-box>

              <v-text-field
                v-model="model.therapieempfehlung.typ_therapieempfehlungen"
                v-show="false"
              ></v-text-field>
            </validation-provider>
          </div>


          <!-- Therapieempfehlung Typ -->

          <div v-bind:style="{'z-index': '4'}" class="layout-row flex layout-align-start-center pa-1">
            <lx-btn :disabled="isDisabled"
                    icon="add_circle"
                    :color="compColor.primeColor"
                    :iconColor="'white'"
                    :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_ADD_RECOMMENDATION')"
                    :tooltip="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_ADD_RECOMMENDATION')"
                    iconSize="21"
                    :width="'auto'"
                    :height="35"
                    @click="addNewRecommendation()"
            ></lx-btn>
          </div>

          <div :key="index" v-for="(item, index) in model.therapieempfehlung.typ_therapieempfehlungen"
               class="layout-row pa-0 ma-1"
               :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
               style="border-radius:4px;"
               :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

            <div class="layout-row layout-wrap flex px-4 pt-4">
              <div class="flex flex-100 px-2">
                <validation-provider tag="div"
                                     :name="path + '.therapieempfehlung.typ_therapieempfehlungen.' + index"
                                     :ref="path + '.therapieempfehlung.typ_therapieempfehlungen.' + index"
                                     rules="required"
                                     v-slot="{ errors }">
                  <v-select
                    :color="compColor.primeColor"
                    :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_TYPE_RECOMMENDATION') + ' *'"
                    v-model="model.therapieempfehlung.typ_therapieempfehlungen[index]"
                    :items="Tumorkonferenz_EmpfehlungTypes"
                    outlined
                    :disabled="isDisabled"
                    :hide-details="!errors || errors.length <= 0"
                    @change="validateRecommendations"
                    :dense="denseFields"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item v-on="on"
                                   :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                        <v-list-item-content class="py-0">
                          <label style="cursor:pointer;"
                                 :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                 class="lighten-4 text--darken-2">{{ item.text }}</label>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </validation-provider>
              </div>
            </div>

            <div class="layout-column layout-align-center-center px-3"
                 :class="{'grey lighten-2': !compColor.isInDarkMode}"
                 :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
              <lx-btn @click="deleteRecommendation(model.therapieempfehlung.typ_therapieempfehlungen, index, path + '.therapieempfehlung.typ_therapieempfehlungen.' + index)"
                      :color="compColor.primeColor"
                      :iconColor="'white'"
                      iconSize="21"
                      :width="35"
                      :height="35"
                      :disabled="isDisabled || model.therapieempfehlung.typ_therapieempfehlungen.length === 1" icon="delete_forever"></lx-btn>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'

export default {
  name: "GrunddatenTumorkonferenz",
  mixins: [metaData],
  props: {
    value: {
      type: Object,
      default: () => ({
        therapieempfehlung: {}
      })
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    patientId: {
      type: String
    },
    addRecommendationItem: {
      type: Function
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    reportHeader: {
      type: Object,
      default: () => ({})
    },
    formId: {
      type: String
    }
  },
  data () {
    return {
      model: {
        therapieempfehlung: {},
        tumorConferenceTypesListItem: null
      },
      Tumorkonferenz_TypTypes: null,
      Tumorkonferenz_EmpfehlungTypes: null,
      DateAccuracyTypes: null
    }
  },
  created () {
    this.Tumorkonferenz_TypTypes = this.formsMetaData.Tumorkonferenz_TypTypes_Long
    this.Tumorkonferenz_EmpfehlungTypes = this.formsMetaData.Tumorkonferenz_EmpfehlungTypes
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyLong
  },
  methods: {
    validateRecommendations () {
      this.$nextTick(() => {
        if (this.$refs[this.path + '.therapieempfehlung.typ_therapieempfehlungen']) {
          this.$refs[this.path + '.therapieempfehlung.typ_therapieempfehlungen'].validate()
        }
      })
    },

    /**
     * Validate date after changing date accuracy
     */
    validateDateAfterChangeOfAccuracy () {
      this.$nextTick(() => {
        if (this.$refs[this.path + '.tumorkonferenz_datum']) {
          this.$refs[this.path + '.tumorkonferenz_datum'].validate()
        }
      })
    },

    /**
     * Set date accuracy per default after date input
     */
    setDateAccuracyAfterDate () {
      // set tumorkonferenz_datum_genauigkeit if not exists after changing tumorkonferenz_datum in datepicker
      if (this.model.tumorkonferenz_datum && !this.model.tumorkonferenz_datum_genauigkeit) {
        this.model.tumorkonferenz_datum_genauigkeit = 'E'
      }
    },

    /**
     * Add new type of recommendation to array
     */
    addNewRecommendation () {
      this.addRecommendationItem(this.path + '.therapieempfehlung.typ_therapieempfehlungen', '')
    },

    /**
     * Delete recommendation from recommendation array
     *
     * @param value The array
     * @param index The index of array
     * @param field The validator field
     */
    deleteRecommendation (value, index, field) {
      this.$delete(value, index)
      this.$nextTick(() => {
        this.validationRef.fields[field].changed = true
      })
    },

    /**
     * Set value of tumorConferenceTypesListItem after loading new or existing form
     *
     * @param type The type of tumor conference e.g. praeth
     * @param reportReason The report reason of form
     * @returns {string}
     */
    setTumorConferenceTypesListItem (type, reportReason) {
      switch (type) {
        case 'praeth':
          if (reportReason === 'diagnose') return 'praethDiagnosis'
          else if (reportReason === 'behandlungsbeginn') return 'praethTreatment'
          else return 'praethState'
        case 'postop':
          return 'postop'
        case 'ther':
          if (reportReason === 'diagnose') return 'therDiagnosis'
          else if (reportReason === 'behandlungsbeginn') return 'therTreatment'
          else return 'therState'
        default:
          // default is postth
          return 'postth'
      }
    }
  },
  computed: {
    diagDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagDate : undefined
    },
    deathDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model =  newValue || {therapieempfehlung: {}}

          // set object of element therapieempfehlung, if not exist, to prevent errors in rendering
          if (!this.model.therapieempfehlung) this.$set(this.model, 'therapieempfehlung', {})

          // set value of tumorConferenceTypesListItem, if type and report reason exist or reset value
          if (this.model.tumorkonferenz_typ && this.reportHeader?.meldeanlass) {
            this.$set(this.model, 'tumorConferenceTypesListItem', this.setTumorConferenceTypesListItem(this.model.tumorkonferenz_typ, this.reportHeader.meldeanlass))
          }
        }
      },
      immediate: true
    }
  }
}
</script>
